<template>
  <div class="main">
    <div class="title">Lettura Contatore</div>
    <Form />
  </div>
</template>

<script>
import Form from '@/components/Form.vue';

export default {
  name: 'Home',
  components: {
    Form,
  },
}
</script>

<style lang="scss" scoped>
.main{
  .title{
    color: white;
    text-align: center;
    font-size: 24px;
    font-weight: 300;
    padding: 16px;
  }
}
</style>
